// helpers
import Storage from 'shared/helpers/storage';

// constants
const FITADVISOR_UUID_IDENTIFIER = 'FIT_ADVISOR_UUID';

export const setUUID = (uuid: string) => {
  Storage.setItem(FITADVISOR_UUID_IDENTIFIER, uuid);
};

export const getUUID = () => {
  return Storage.getItem<string>(FITADVISOR_UUID_IDENTIFIER);
};
